<script setup lang="ts">
import SearchInput from '../sections/SearchInput.vue';
import InsightModal from '../sections/InsightModal.vue';

interface InsightResult {
  type: 'users' | 'user' | 'calendar';
  title: string;
  meta: string;
  showExpand?: boolean;
}

interface Step {
  placeholder: string;
  ghost: string;
}

defineProps<{
  displayedText: string;
  isTyping: boolean;
  step: Step;
  results: InsightResult[];
}>();

defineEmits<{
  (e: 'update:activeStep', step: number): void;
}>();
</script>

<template>
  <div class="step-container">
    <SearchInput 
      :displayedText="displayedText" 
      :isTyping="isTyping"
      :placeholder="step.placeholder"
      :ghost="step.ghost"
    />
    
    <InsightModal 
      :displayedText="displayedText"
      :results="results"
      @update:activeStep="$emit('update:activeStep', $event)"
    />
  </div>
</template>

<style scoped>
.step-container { width: 100%; height: 100%; position: relative; }
</style>
